import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { DashboardCartAndSettings } from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/dashboard-cart-and-settings';
import { IWidgetSettings } from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/widget-settings';
import { BaseDynamicLayoutHeaderComponent } from '@common-modules/dynamic-layout/base-dynamic-layout-header.component';
import { ReduxStateService } from '@common-modules/redux/redux-state.service';
import { DashboardManagerService } from '@common-modules/right-panel/dashboards/dashboard-manager.service';
import { AppModules } from '@common-modules/shared/app-modules.enum';
import { DialogService } from '@common-modules/shared/dialogs/dialogs.service';
import { globalUtilsHelper } from '@common-modules/shared/helpers/global-utils-helper';
import { DashboardChildConfigPopupData } from '../dashboard-child-config-popup/dashboard-child-config-popup-data';
import { DashboardChildConfigPopupComponent } from '../dashboard-child-config-popup/dashboard-child-config-popup.component';

const COMPONENT_SELECTOR = 'ct-dashboard-header-toolbar';

@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './dashboard-header-toolbar.component.html',
  styleUrl: './dashboard-header-toolbar.component.scss',
  standalone: false,
})
export class DashboardHeaderToolbarComponent
  extends BaseDynamicLayoutHeaderComponent
  implements OnInit
{
  private readonly _dialogService = inject(DialogService);
  readonly T_SCOPE = `${AppModules.RightPanel}.${COMPONENT_SELECTOR}`;
  private readonly _dashboardManagerService = inject(DashboardManagerService);
  private readonly _state = inject(ReduxStateService);
  protected readonly _destroyRef = inject(DestroyRef);
  private _widgetSettings: IWidgetSettings;

  ngOnInit() {}

  openSettingsPopup(): void {
    const config = new MatDialogConfig();
    const itemSettings = this.getItemSetting();

    const data: DashboardChildConfigPopupData = globalUtilsHelper.clone(
      itemSettings.params as DashboardCartAndSettings,
      true
    );

    // data.widgetSettings = this._widgetSettings;

    config.data = data;
    config.width = '80vw';
    config.height = '90vh';
    const dialogRef = this._dialogService.openComponent(DashboardChildConfigPopupComponent, config);
    dialogRef.afterClosed().subscribe((updatedCartAndSettings: DashboardCartAndSettings) => {
      if (updatedCartAndSettings) {
        this._dashboardManagerService.updateDashboardChild(updatedCartAndSettings);
      }
    });
  }
}
